import { __module as o } from "./chunk777.js";
import { __require as u } from "./chunk648.js";
import { __require as d } from "./chunk665.js";
var s = o.exports, n;
function _() {
  return n ? o.exports : (n = 1, function(a, p) {
    (function(e, r, i) {
      a.exports = r(u(), d());
    })(s, function(e) {
      return e.pad.Iso97971 = {
        pad: function(r, i) {
          r.concat(e.lib.WordArray.create([2147483648], 1)), e.pad.ZeroPadding.pad(r, i);
        },
        unpad: function(r) {
          e.pad.ZeroPadding.unpad(r), r.sigBytes--;
        }
      }, e.pad.Iso97971;
    });
  }(o), o.exports);
}
export {
  _ as __require
};
